export default __webpack_public_path__ + "static/media/blueberry.0deb15de.svg";